import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    const options = {
      plugins: ['remove_button'],
      maxOptions: null,
      clearAfterSelect: true,
      render: {
        option: (data, escape) => this.renderOption(data, escape),
        item: (data, escape) => this.renderOption(data, escape)
      }
    }

    this.tom = new TomSelect(this.element, options)
  }

  renderOption(option, escape) {
    const label = option.label
    const days = option.days
    const rangeText = option.rangeText

    if (!days || !rangeText) {
      // For custom_dates which has no range
      return `<div>${escape(label)}</div>`
    }

    return `<div class="date-range-option">
      <div class='d-inline-block'>
      <div class="date-range-label">${escape(label)}</div>
      <div class="date-range-details small text-muted">
        ${escape(days)} days • ${escape(rangeText)}
      </div>
      </div>
    </div>`
  }

  disconnect() {
    if (this.tom) {
      this.tom.destroy()
    }
  }
}
